import { createContext } from 'react'

interface IRouteDetailsContext {
    readOnly: boolean
    workstationNumber: string
}

export const RouteDetailsContext = createContext<IRouteDetailsContext>({
    readOnly: false,
    workstationNumber: '',
})
